import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear, BsSendCheck } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { BiSolidDashboard } from "react-icons/bi";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">

									

									<div
										className="d-flex mb-4 mt-4"
										style={{
											padding: "0",
											cursor: "pointer",
										}}
										onClick={() => {
											appContext.navTo({
												item: 'integrated-apps',
												subItem: 'mauzocrm',
											})
										}}
									>
										<BiSolidDashboard className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
										<h6
											className="mNoMargin align-self-center font-semi-bold"
											style={{
												fontSize: "14px",
												paddingLeft: "20px",
											}}
										>
											Mauzo CRM & Accounting
										</h6>
									</div>

									

								</div>
							</div>
						</div>

						

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}